require('jquery')
require('jquery_migrate')
require('select2')
require('jquery_validate')
require('jquery_easing')
require('jquery_waypoints')
require('fancybox')
require('jquery_numeric')

Modernizr = require('modernizr');
require('./app/animations.coffee')
require('./app/header.coffee')
require('./app/sites_list.coffee')
require('./app/page_popup.coffee')
require('./app/age_popup.coffee')
require('./app/side_menu.coffee')

window.pageInitCommonFlag = false
tooltip = require('tooltip')
tooltip()
pageInit = ->
  
  window.Animations = new window.Animations()
  window.popupObject = new window.PagePopup()

  new window.Header()
  new window.SitesList()
  new window.AgePopup()

  if Modernizr.cssgrid
    $('body').removeClass('old-browser-fix-wrapper')
  else
    $('body').addClass('old-browser-fix-wrapper')


$(document).ready ->
  if window.pageInitCommonFlag != true
    pageInit()
  window.pageInitCommonFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/common.coffee